import React from 'react'

const MapContext = React.createContext(null)
export default MapContext
